function Careers() {
  return (
    <>
      <header>
        <div id="carouselExampleCaptions" className="carousel slide hm-slider">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src="/img/services-banner.jpg"
                className="d-block w-100"
                alt="..."
              />
            </div>
          </div>
        </div>
      </header>
      <section className="stats-section">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6">
              <div className="stat-item">
                <i className="fa fa-users"></i>
                <h3>300+</h3>
                <p>Happy Employees</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="stat-item">
                <i className="fa fa-building"></i>
                <h3>25+</h3>
                <p>Years of Excellence</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="stat-item">
                <i className="fa fa-trophy"></i>
                <h3>18+</h3>
                <p>Projects Completed</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="stat-item">
                <i className="fa fa-star"></i>
                <h3>15+</h3>
                <p>Industry Awards</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="why-join-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title text-center mb-5">
                <h1>Join Our Team</h1>
                <p className="section-subtitle">
                  Build your career with Shree Mahavir Group
                </p>
              </div>
            </div>
          </div>
          <div className="row align-items-stretch">
            <div className="col-lg-6 mb-4">
              <div className="career-from-image">
                <img
                  src="/img/careerimage.png"
                  alt="Career Image"
                  className="career-image"
                />
              </div>
            </div>

            <div className="col-lg-6 mb-4 d-flex">
              <div className="career-form-card w-100">
                <h3>Apply Now</h3>
                <p className="mb-4">
                  Send us your details and we'll get back to you!
                </p>

                <div className="form-group">
                  <label className="required">Job Application For</label>
                  <select className="form-control" id="candidatePosition" required>
                    <option value="">Select Position</option>
                    <option value="Architect">Architect</option>
                    <option value="Site Engineer">Site Engineer</option>
                    <option value="Sales Executive">Sales Executive</option>
                    <option value="Sales Manager">Sales Manager</option>
                    <option value="HR">HR</option>
                    <option value="Business Development">Business Development</option>
                    <option value="Accountant">Accountant</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <form id="careerForm">
                  <div className="form-group">
                    <label className="required">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="candidateName"
                      placeholder="Enter your full name"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label className="required">Phone Number</label>
                    <input
                      type="tel"
                      className="form-control"
                      id="candidatePhone"
                      placeholder="Enter your phone number"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label className="required">Email Address</label>
                    <input
                      type="email"
                      className="form-control"
                      id="candidateEmail"
                      placeholder="Enter your email"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label className="required">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      id="candidateSubject"
                      placeholder="Enter subject for your application"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label className="required">Experience</label>
                    <select
                      className="form-control"
                      id="candidateExperience"
                      required
                    >
                      <option value="">Select Experience</option>
                      <option value="Fresher">Fresher</option>
                      <option value="0-2 Years">0-2 Years</option>
                      <option value="2-5 Years">2-5 Years</option>
                      <option value="5-8 Years">5-8 Years</option>
                      <option value="8-12 Years">8-12 Years</option>
                      <option value="12+ Years">12+ Years</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Resume Link (Optional)</label>
                    <input
                      type="url"
                      className="form-control"
                      id="candidateResume"
                      placeholder="Paste your resume link (Google Drive, Dropbox, etc.)"
                    />
                  </div>

                  <div className="form-group">
                    <label>Message (Optional)</label>
                    <textarea
                      className="form-control"
                      id="candidateMessage"
                      rows="4"
                      placeholder="Add any additional message or information about your application..."
                    ></textarea>
                  </div>

                  <button type="submit" className="btn-apply w-100">
                    <i className="fab fa-whatsapp"></i> Send via WhatsApp
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Careers;